import { createMutation, createResource } from "@evergis/react-fetching";
import { EqlRequestDc, SetLayerParametersPayload, SetLayerParameterValueParams } from "@evergis/api";

import { features } from "./features";

import { api as evergisApi } from "../evergis/api";

export const getEqlParams = createResource(
  (layerName: string) => async api => ({
    data: await api.eql.getLayerParameters1({ layerName }),
  }),
  {
    injected: evergisApi,
  },
);

export const getEqlParam = createResource(
  ({ layerName, paramName }: { layerName: string; paramName: string }) =>
    async api => ({
      data: await api.eql.getLayerParameters({ layerName, paramName }),
    }),
  {
    injected: evergisApi,
  },
);

export const setEqlParams = createMutation(
  ({ layerName, payload }: { layerName: string; payload: SetLayerParametersPayload }) =>
    async api => ({
      data: {
        result: await api.eql.setLayerParameters({ layerName }, payload),
        layerName,
      },
    }),
  {
    injected: evergisApi,
    update: () => {
      features.invalidateAll();
      getEqlParams.invalidateAll();
    },
  },
);

export const setEqlParam = createMutation(
  (query: SetLayerParameterValueParams) => async api => ({
    data: {
      result: await api.eql.setLayerParameterValue(query),
      layerName: query.layerName,
    },
  }),
  {
    injected: evergisApi,
    update: () => {
      features.invalidateAll();
      getEqlParams.invalidateAll();
    },
  },
);

export const eqlDescription = createResource(
  (params: EqlRequestDc) => async api => ({
    data: await api.eql.getQueryDescription(params),
  }),
  {
    injected: evergisApi,
  },
);

export const createEqlQuery = createMutation(
  (queryInput: EqlRequestDc) => async api => ({
    data: await api.eql.getQueryResult(queryInput),
  }),
  {
    injected: evergisApi,
  },
);
